import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initReviews() {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.js-reviews-carousel').forEach((el) => {
            const count = parseInt(el.dataset.count, 10) || 0;

            // Determine slides visible at the current viewport width
            const w = window.innerWidth;
            const slidesVisible = w >= 1700 ? 5.1 : w >= 1400 ? 4.1 : w >= 1024 ? 2.4 : w >= 640 ? 1.6 : 1.4;
            const fitsInView = count <= Math.floor(slidesVisible);

            if (fitsInView) {
                el.classList.add('flex-reviews__carousel--centered');
            }

            new Swiper(el, {
                modules: [Navigation],
                slidesPerView: fitsInView ? count : 1.4,
                spaceBetween: -1,
                loop: !fitsInView,
                speed: 600,
                grabCursor: !fitsInView,
                centeredSlides: false,
                breakpoints: fitsInView ? {} : {
                    640: {
                        slidesPerView: 1.6,
                    },
                    1024: {
                        slidesPerView: 2.4,
                    },
                    1400: {
                        slidesPerView: 4.1,
                    },
                    1700: {
                        slidesPerView: 5.1,
                    },
                },
            });
        });
    });
}
